import React from "react";
import { Button } from "primereact/button";
import { classNames } from "primereact/utils";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { useAppContext } from "../../../context/appContext";
import { InputText } from "primereact/inputtext";
import { InputMask } from "primereact/inputmask";
import { Dropdown } from "primereact/dropdown";
import DataUtils from "../../../utils/DataUtils";
import idApi from "../../../service/IdApi";
import { useMutation } from "react-query";
import TokenService from "../../../utils/TokenService";
import PageHeading from "../../../components/PageHeading";
import { InputSwitch } from "primereact/inputswitch";
import { Checkbox } from "primereact/checkbox";
import { usStates } from "../../../utils/AddressHelper";
import { throttle } from "lodash";

const NewUnclaimedProfile = () => {
    const { countries, displayAlert } = useAppContext();
    const [submitted, setSubmitted] = useState(false);
    const [changesMade, setChangesMade] = useState(false);
    const [companyNameChangesMade, setCompanyNameChangesMade] = useState(false);
    const [uriChangesMade, setUriChangesMade] = useState(false);
    const [companyName, setCompanyName] = useState("");
    const [uri, setUri] = useState("");
    const [invalidUri, setInvalidUri] = useState(false);
    const [invalidCompanyName, setInvalidCompanyName] = useState(false);
    const [invalidState, setInvalidState] = useState(false);
    const [invalidCountry, setInvalidCountry] = useState(false);
    const [invalidCity, setInvalidCity] = useState(false);
    const [zipCode, setZipCode] = useState("");
    const [invalidZipCode, setInvalidZipCode] = useState(false);
    const [isProcessing, setIsProcessing] = useState(false);
    const [city, setCity] = useState("");
    const [address, setAddress] = useState("");
    const [address2, setAddress2] = useState("");
    const [website, setWebsite] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("");
    const [emailAddress, setEmailAddress] = useState("");
    const [invalidEmailAddress, setInvalidEmailAddress] = useState(false);
    const [showEmailOnPublicSite, setShowEmailOnPublicSite] = useState(false);
    const [showPhoneOnPublicSite, setShowPhoneOnPublicSite] = useState(false);
    const [invalidWebsite, setInvalidWebsite] = useState(false);
    const [selectedUsState, setSelectedUsState] = useState({ name: 'Nebraska', code: 'NE' });
    const [selectedCountry, setSelectedCountry] = useState({ name: "United States", code: "US" });
    const navigate = useNavigate();

    const createProfileApi = useMutation(() => {
        var body = {};
        body.name = companyName.trim();
        body.uri = uri.trim();
        body.zipCode = zipCode.trim();
        body.city = city.trim();
        body.stateCode = selectedUsState.code;
        body.stateName = selectedUsState.name;
        body.countryCode = selectedCountry.code;
        body.countryName = selectedCountry.name;
        body.address = address.trim();
        body.address2 = address2.trim();
        body.website = website.trim();
        body.phoneNumber = phoneNumber;
        body.emailAddress = emailAddress.trim();
        body.unclaimedEmailVisibility = showEmailOnPublicSite ? "s" : "h";
        body.unclaimedPhoneVisibility = showPhoneOnPublicSite ? "s" : "h";
        try {
            const data = idApi.post("admin/unclaimed-provider", body, {
                withCredentials: true,
            }).then((response) => response.data);
            return data;
        } catch (error) {
            throw error;
        }
    });

    const save = (e) => {
        e.preventDefault();
        submitAction();
    };

    const onSubmit = (e) => {
        e.preventDefault();
        submitAction();
    }

    const submitAction = throttle(() => {
        setIsProcessing(true);
        setSubmitted(true);
        if (companyName.trim() === "") {
            displayAlert("error", "Error", "Company Name is required");
            setInvalidCompanyName(true);
            setIsProcessing(false);
            return;
        }
        if (companyName.trim().length < 3) {
            displayAlert("error", "Validation Error", "Company Name must be at least 3 characters");
            setInvalidCompanyName(true);
            setIsProcessing(false);
            return;
        }
        setInvalidCompanyName(false);

        // validate website
        // if (website.trim() === "") {
        //     displayAlert("error", "Validation Error", "Website is required");
        //     setIsProcessing(false);
        //     setInvalidWebsite(true);
        //     return;
        // }
        if (website.trim() !== "") {
            try {
                new URL(website);
            } catch (_) {
                displayAlert("error", "Validation Error", "Website must be a full URL including http:// or https://");
                setIsProcessing(false);
                setInvalidWebsite(true);
                return;
            }
        }
        setInvalidWebsite(false);

        // validate vanity URL
        if (uri.trim() === "") {
            displayAlert("error", "Error", "Wallist Profile URL is required");
            setInvalidUri(true);
            setIsProcessing(false);
            return;
        }
        if (uri.trim().length < 3) {
            displayAlert("error", "Validation Error", "The URL must be at least 3 characters");
            setInvalidUri(true);
            setIsProcessing(false);
            return;
        }
        var isValidUri = /^[A-Za-z0-9-]*$/.test(uri);
        if (!isValidUri) {
            displayAlert("error", "Validation Error", "The URL can only contain letters, numbers, and hyphens");
            setInvalidUri(true);
            setIsProcessing(false);
            return;
        }
        setInvalidUri(false);

        // validate the email address
        const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
        if (emailAddress.trim() !== "" && !emailRegex.test(emailAddress)) {
            displayAlert("error", "Error", "Please enter a valid email address");
            setIsProcessing(false);
            setInvalidEmailAddress(true);
            return;
        }
        setInvalidEmailAddress(false);

        if (selectedCountry.code !== "US") {
            displayAlert("error", "Error", "The only country supported at this time is the United States");
            setInvalidCountry(true);
            setIsProcessing(false);
            return;
        }
        setInvalidCountry(false);
        // validate the city
        if (city.trim() === "") {
            displayAlert("error", "Error", "City is required");
            setInvalidCity(true);
            setIsProcessing(false);
            return;
        }
        setInvalidCity(false);
        // validate the state
        if (selectedUsState.code === "") {
            displayAlert("error", "Error", "State is required");
            setInvalidState(true);
            setIsProcessing(false);
            return;
        }
        setInvalidState(false);
        if (zipCode.trim() === "") {
            displayAlert("error", "Error", "Zip code is required");
            setInvalidZipCode(true);
            setIsProcessing(false);
            return;
        }
        if (!DataUtils.isUSZipValid(zipCode.trim(), false)) {
            displayAlert("error", "Error", "Zip code format is invalid");
            setInvalidZipCode(true);
            setIsProcessing(false);
            return;
        }
        setInvalidZipCode(false);

        // const { name, subdomain } = values;
        createProfileApi.mutate({}, {
            onError: (error, variables, context) => {
                if (error && error.request.status === 409) {
                    displayAlert("error", "Unexpected Error", "This URL is taken. Please use a different value.");
                }
                else {
                    displayAlert("error", "Unexpected Error", "Please try again later");
                }
                setIsProcessing(false);
            },
            onSuccess: (data) => {
                TokenService.setAccessToken(data.userAccessToken);
                TokenService.setRefreshToken(data.userRefreshToken);
                // displayAlert("success", "Success", "Unclaimed profile created successfully");
                // navigate("/account/admin/unclaimed-profiles");
                window.location.href = process.env.REACT_APP_NETWORK_SITE + "/company/" + TokenService.getProviderVanityUrl();

            },
        });
    }, 500, { trailing: false });

    const handleUriChange = (e) => {
        setChangesMade(true);
        setUriChangesMade(true);
        setUri(e.target.value);
    };

    const handleZipChange = (e) => {
        setZipCode(e.target.value);
        setChangesMade(true);
    };

    const handleCompanyNameChange = (e) => {
        setChangesMade(true);
        setCompanyNameChangesMade(true);
        setCompanyName(e.target.value);
        if (!uriChangesMade) {
            // we should suggest a URI
            // replace spaces with hyphens
            var withoutSpaces = e.target.value.replace(/\s/g, '-');
            var withoutBadChars = withoutSpaces.replace(/[^A-Za-z0-9-]/g, '');
            setUri(withoutBadChars);
        }
    };

    const handleUsStateChange = (e) => {
        setSelectedUsState(e.value);
        setChangesMade(true);
    };

    const handleCityChange = (e) => {
        setCity(e.target.value);
        setChangesMade(true);
    };

    const handleAddressChange = (e) => {
        setAddress(e.target.value);
        setChangesMade(true);
    };

    const handleAddress2Change = (e) => {
        setAddress2(e.target.value);
        setChangesMade(true);
    };

    const cancel = (e) => {
        navigate("/account/admin/all-profiles");
    };

    const handleCountryChange = (e) => {
        setSelectedCountry(e.value);
        setChangesMade(true);
    };

    const handleWebsiteChange = (e) => {
        setChangesMade(true);
        setWebsite(e.target.value);
    };

    const handlePhoneChange = (e) => {
        setChangesMade(true);
        setPhoneNumber(e.target.value);
    };

    const onEmailAddressChange = (e) => {
        setChangesMade(true);
        setEmailAddress(e.target.value);
    };

    const pageHeader = (
        <PageHeading pageTitle="Create Unclaimed Profile">
            <div className="block">
                <Button label="Submit" icon="pi pi-check" className="mr-2" disabled={!changesMade} onClick={save} loading={isProcessing} />
                <Button label="Cancel" icon="pi pi-times" className="p-button-danger" onClick={cancel} />
            </div>
        </PageHeading>
    );
    return (
        <div >
            {pageHeader}
            <div className="layout-content">
                <div className="pages-panel card flex flex-column">
                    <form className="form" onSubmit={onSubmit}>
                        <div className="p-fluid formgrid grid text-left">
                            <div className="field col-12">
                                <label htmlFor="name" className={classNames("required", { "text-pink-400": submitted && invalidCompanyName })}>
                                    Company Name
                                </label>
                                <InputText
                                    id="companyName"
                                    name="companyName"
                                    value={companyName}
                                    onChange={handleCompanyNameChange}
                                    className={classNames({ "p-invalid": submitted && invalidCompanyName })}
                                    maxLength={46}
                                    required
                                    autoFocus
                                />
                            </div>
                            <div className="field col-12">
                                <label htmlFor="website" className={classNames("", { "text-pink-400": submitted && invalidWebsite })}>Website</label>
                                <InputText
                                    id="website"
                                    name="website"
                                    value={website}
                                    onChange={handleWebsiteChange}
                                    placeholder="https://"
                                    className={classNames({ "p-invalid": submitted && invalidWebsite })}
                                    maxLength={100}
                                />
                            </div>
                            <div className="field col-12">
                                <label htmlFor="uri" className={classNames("mr-3 required", { "text-pink-400": submitted && invalidUri })}>
                                    Wallist Profile URL
                                </label>
                                <div className="p-inputgroup">
                                    <span className="p-inputgroup-addon pr-0 mr-0">
                                        wallist.com/company/
                                    </span>
                                    <InputText
                                        id="uri"
                                        name="uri"
                                        value={uri}
                                        onChange={handleUriChange}
                                        required
                                        className={classNames("ml-0 pl-0", { "p-invalid": submitted && invalidUri })}
                                        maxLength={75}
                                    />
                                </div>
                            </div>

                            <div className="field col-12">
                                <label htmlFor="emailAddress" className={classNames("required", { "text-pink-400": submitted && invalidEmailAddress })}>Email Address</label>
                                <InputText
                                    id="emailAddress"
                                    name="emailAddress"
                                    value={emailAddress}
                                    onChange={onEmailAddressChange}
                                    className={classNames("ml-0 pl-0", { "p-invalid": submitted && invalidEmailAddress })}
                                    maxLength={128}
                                    required
                                />
                            </div>
                            <div className="field col-12">
                                <div className="flex align-items-start gap-2">
                                    <Checkbox
                                        inputId="showEmailOnPublicSite"
                                        checked={showEmailOnPublicSite}
                                        onChange={(e) => {
                                            setChangesMade(true);
                                            setShowEmailOnPublicSite(e.checked === true);
                                        }}
                                    />
                                    <label htmlFor="showEmailOnPublicSite" className="m-0 cursor-pointer">
                                        Show email on public site
                                    </label>
                                </div>
                                <div className="text-sm text-600 mt-1">
                                    Turn on only if this business already lists this email publicly (for example on Facebook or Google).
                                </div>
                            </div>

                            <div className="field col-12">
                                <label htmlFor="phoneNumber">Phone Number</label>
                                <InputMask
                                    id="phoneNumber"
                                    mask="(999) 999-9999"
                                    name="phoneNumber"
                                    onChange={handlePhoneChange}
                                    value={phoneNumber}
                                    unmask
                                />
                            </div>
                            <div className="field col-12">
                                <div className="flex align-items-start gap-2">
                                    <Checkbox
                                        inputId="showPhoneOnPublicSite"
                                        checked={showPhoneOnPublicSite}
                                        onChange={(e) => {
                                            setChangesMade(true);
                                            setShowPhoneOnPublicSite(e.checked === true);
                                        }}
                                    />
                                    <label htmlFor="showPhoneOnPublicSite" className="m-0 cursor-pointer">
                                        Show phone number on public site
                                    </label>
                                </div>
                                <div className="text-sm text-600 mt-1">
                                    Turn on only if this business already lists this phone number publicly (for example on Facebook or Google).
                                </div>
                            </div>
                            <div className="field col-12">
                                <label htmlFor="address">Address</label>
                                <InputText
                                    id="address"
                                    name="address"
                                    value={address}
                                    type="text"
                                    onChange={handleAddressChange}
                                    className="ml-0 pl-0"
                                    maxLength={46}
                                />
                            </div>
                            <div className="field col-12">
                                <label htmlFor="address2">Address 2</label>
                                <InputText
                                    id="address2"
                                    name="address2"
                                    value={address2}
                                    type="text"
                                    onChange={handleAddress2Change}
                                    className="ml-0 pl-0"
                                    maxLength={46}
                                />
                            </div>
                            <div className="field col-12">
                                <label htmlFor="city" className={classNames("required", { "text-pink-400": submitted && invalidCity })}>City</label>
                                <InputText
                                    id="city"
                                    name="city"
                                    value={city}
                                    type="text"
                                    onChange={handleCityChange}
                                    className={classNames("ml-0 pl-0", { "p-invalid": submitted && invalidCity })}
                                    maxLength={50}
                                />
                            </div>
                            <div className="field col-12">
                                <label htmlFor="state" className={classNames("required", { "text-pink-400": submitted && invalidState })}>State</label>
                                <Dropdown
                                    id="state"
                                    name="state"
                                    value={selectedUsState}
                                    onChange={handleUsStateChange}
                                    options={usStates}
                                    optionLabel="name"
                                    placeholder="Select One"
                                    className={classNames("ml-0 pl-0", { "p-invalid": submitted && invalidState })}
                                ></Dropdown>
                            </div>
                            <div className="field col-12">
                                <label htmlFor="zipCode" className={classNames("required", { "text-pink-400": submitted && invalidZipCode })}>
                                    Zip Code
                                </label>
                                <InputText
                                    id="zipCode"
                                    name="zipCode"
                                    value={zipCode}
                                    onChange={handleZipChange}
                                    className={classNames("ml-0 pl-0", { "p-invalid": submitted && invalidZipCode })}
                                    maxLength="10"
                                />
                            </div>
                            <div className="field col-12">
                                <label htmlFor="country" className={classNames("required", { "text-pink-400": submitted && invalidCountry })}>Country</label>
                                <Dropdown
                                    id="country"
                                    name="country"
                                    value={selectedCountry}
                                    defaultValue="US"
                                    onChange={handleCountryChange}
                                    options={countries}
                                    optionLabel="name"
                                    className={classNames("ml-0 pl-0", { "p-invalid": submitted && invalidCountry })}
                                    placeholder="Select One"
                                ></Dropdown>
                            </div>
                        </div>
                        <input type="submit" style={{ display: "none" }} />
                    </form>
                </div>
            </div>
        </div>
    );
};

export default NewUnclaimedProfile;
